<template>
  <div class="card border-2 p-3 mb-3 team-card">
    <div class="d-flex gap-2">
      <img :src="team_avatar" class="rounded-circle" width="40" alt="" />
      <div class="d-flex flex-column">
        <h5 class="fw-bold fs-6 mb-1">{{ team_name }}</h5>
        <div class="fs-14px d-flex text-secondary inline-list">
          <span>{{ team_users }} المستخدمين</span>
          <span>{{ team_meetings }} موعد</span>
        </div>
    </div>
      <div class="ms-auto d-flex align-items-center">
        <button class="btn text-secondary">
          <img src="@/assets/images/cog.svg" width="19" alt="" /> تخصيص
        </button>
        <button class="btn text-secondary" @click="visibility = !visibility">
          <img src="@/assets/images/dots.svg" alt="" />
        </button>
      </div>
    </div>
    <div v-if="visibility">
      <div class="border border-2 my-4"></div>
      <div>
        <h5 class="fs-6 fw-bold">الفريق</h5>
        <UserCard :classes="'d-flex bg-secondary align-items-center gap-2 p-2 user-card mb-2'" v-for="user in users" :key="user.id" :user="user" />
      </div>
      <div>
        <button
          data-bs-toggle="modal"
          data-bs-target="#inviteModal"
          class="btn btn-outline-primary rounded-pill d-flex gap-2 fw-bold"
        >
          <div class="svg-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <g id="plus" transform="translate(-4 -4)">
                <path
                  id="Line_1"
                  data-name="Line 1"
                  d="M-.086,13A.9.9,0,0,1-1,12.125V-.125A.9.9,0,0,1-.086-1a.9.9,0,0,1,.914.875v12.25A.9.9,0,0,1-.086,13Z"
                  transform="translate(11.086 5)"
                  fill="currentColor"
                />
                <path
                  id="Line_2"
                  data-name="Line 2"
                  d="M12.125.828H-.125A.9.9,0,0,1-1-.086.9.9,0,0,1-.125-1h12.25A.9.9,0,0,1,13-.086.9.9,0,0,1,12.125.828Z"
                  transform="translate(5 11.086)"
                  fill="currentColor"
                />
              </g>
            </svg>
          </div>
          دعوة مستخدم للفريق
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import UserCard from "../components/UserCard.vue";
export default {
  components: { UserCard },
  props: ["team_name", "team_users", "team_meetings", "team_avatar"],
  setup() {
    const visibility = ref(false);
    const users = ref([
      {
        id: 1,
        email: "medhataudeh@gmail.com",
        permission: "Admin",
      },
      {
        id: 2,
        email: "hussam3bd@gmail.com",
        permission: "Admin",
      },
    ]);
    return { users, visibility };
  },
};
</script>

<style>
</style>